// Verfassen in eigenem Fenster: /compose/:draftId (aus der Seitenleiste „Verfassen“ oder per Link)
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import type { Draft } from '@mail/shared';
import { api } from '../lib/api.ts';
import { useStore } from '../lib/store.ts';
import { ReplyBox } from '../components/ReplyBox.tsx';
import { toast } from '../components/Toast.tsx';

export function ComposePage() {
  const { draftId } = useParams();
  const nav = useNavigate();
  const { mailboxes, me } = useStore((s) => ({ mailboxes: s.mailboxes, me: s.me }));
  const [draft, setDraft] = useState<Draft | null>(null);
  const [fehler, setFehler] = useState('');
  useEffect(() => {
    if (!draftId) return;
    api
      .draft(draftId)
      .then(setDraft)
      .catch(() => setFehler('Entwurf nicht gefunden.'));
  }, [draftId]);
  const mb = mailboxes.find((m) => m.id === draft?.mailboxId);
  if (fehler) return <div className="compose-page">{fehler}</div>;
  if (!draft) return <div className="compose-page" />;
  return (
    <div className="compose-page">
      <ReplyBox
        key={draft.id}
        draft={draft}
        standalone
        mailboxes={mailboxes.filter((m) => m.visibility === 'shared' || m.owner === me?.key)}
        bobEnabled={!!mb?.bobEnabled}
        onDiscard={() => void api.deleteDraft(draft.id).then(() => void nav('/'))}
        onSent={({ undo }) => {
          toast('Gesendet', {
            undo: () => undo().then(() => toast('Senden abgebrochen – der Entwurf ist noch da.')),
          });
          void nav('/');
        }}
      />
    </div>
  );
}
